"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useScript = _interopRequireDefault(require("@hooks/useScript"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["loading", "onReady", "onSubmit", "submitDisabled", "submitBlock", "blockedDomains", "className", "scriptProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var globalId = 0;

if (typeof window !== 'undefined') {
  window.jQuery = window.jQuery || function () {
    return {
      serializeArray: function serializeArray() {},
      dispatchEvent: function dispatchEvent() {}
    };
  };
}

var HubspotForm = function HubspotForm(_ref) {
  var loading = _ref.loading,
      onReady = _ref.onReady,
      onSubmit = _ref.onSubmit,
      _ref$submitDisabled = _ref.submitDisabled,
      submitDisabled = _ref$submitDisabled === void 0 ? false : _ref$submitDisabled,
      submitBlock = _ref.submitBlock,
      blockedDomains = _ref.blockedDomains,
      className = _ref.className,
      _ref$scriptProps = _ref.scriptProps,
      scriptProps = _ref$scriptProps === void 0 ? {
    async: false
  } : _ref$scriptProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var elementRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMounted = _useState4[0],
      setMounted = _useState4[1];

  var status = (0, _useScript["default"])('//js.hsforms.net/forms/v2.js', scriptProps);

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      id = _useState6[0],
      setId = _useState6[1];

  var touched = (0, _react.useRef)({}).current;
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined') {
      return;
    }

    globalId++;
    setId("reactHubspotForm".concat(globalId));
  }, [setId]);
  var setupSubmitDisabled = (0, _react.useCallback)(function (value) {
    if (!elementRef.current) {
      return;
    }

    var input = elementRef.current.querySelector('input[type="submit"]');

    if (input) {
      input.disabled = value;

      if (input.parentNode) {
        input.parentNode.dataset.disabled = value;
      }
    }
  }, [elementRef]);

  var _onFormReady = (0, _react.useCallback)(function () {
    var _ref2, _elementRef$current;

    if (!elementRef.current) {
      return;
    }

    var inputs = (_ref2 = _toConsumableArray(elementRef.current.querySelectorAll('input[type="text"],input[type="email"],input[type="tel"],input[type="number"],input[type="date"],textarea'))) !== null && _ref2 !== void 0 ? _ref2 : [];

    var onFocus = function onFocus(e) {
      var _target$dataset;

      var target = e === null || e === void 0 ? void 0 : e.target;

      if (target !== null && target !== void 0 && (_target$dataset = target.dataset) !== null && _target$dataset !== void 0 && _target$dataset.error) {
        var _target$parentNode;

        delete target.dataset.error;
        var item = (_target$parentNode = target.parentNode) === null || _target$parentNode === void 0 ? void 0 : _target$parentNode.parentNode;
        var label = item === null || item === void 0 ? void 0 : item.querySelector('[data-error-message]');

        if (label) {
          label.remove();
        }

        setupSubmitDisabled(false);
      }
    };

    var onBlur = function onBlur(e) {
      var _touched;

      var target = e === null || e === void 0 ? void 0 : e.target; // eslint-disable-next-line react-hooks/exhaustive-deps

      touched = _objectSpread(_objectSpread({}, touched), {}, _defineProperty({}, target.name, true));

      if ((_touched = touched) !== null && _touched !== void 0 && _touched[target.name]) {
        setTimeout(function () {
          var disabled = inputs.some(function (input) {
            return input.className.includes('hubspot-field-with-error');
          });
          setupSubmitDisabled(disabled); // wait to error className to be applied
        }, 10);
        return;
      }
    };

    inputs.forEach(function (input) {
      input === null || input === void 0 ? void 0 : input.addEventListener('focus', onFocus);
      input === null || input === void 0 ? void 0 : input.addEventListener('blur', onBlur);
    });

    if (elementRef !== null && elementRef !== void 0 && (_elementRef$current = elementRef.current) !== null && _elementRef$current !== void 0 && _elementRef$current.childNodes[0]) {
      var _elementRef$current2;

      elementRef === null || elementRef === void 0 ? void 0 : (_elementRef$current2 = elementRef.current) === null || _elementRef$current2 === void 0 ? void 0 : _elementRef$current2.childNodes[0].addEventListener('submit', function (ev) {
        var disabled = inputs.some(function (input) {
          return input.className.includes('hubspot-field-with-error');
        });
        setupSubmitDisabled(disabled);
      });
    }

    setupSubmitDisabled(submitDisabled);
  }, [elementRef, submitDisabled, touched]);

  (0, _react.useEffect)(function () {
    if (id && isMounted) {
      var createForm = function createForm() {
        if (!window.hbspt || !elementRef.current) {
          return;
        }

        var options = _objectSpread({
          blockedDomains: blockedDomains ? blockedDomains : [],
          errorClass: "".concat(_stylesModule["default"]['with-error'], " hubspot-field-with-error"),
          errorMessageClass: _stylesModule["default"]['error-message'],
          submitButtonClass: _stylesModule["default"].submit,
          target: "#".concat(id),
          onFormSubmit: function onFormSubmit($form) {
            var formData = $form.serializeArray();

            if (onSubmit) {
              onSubmit(formData);
            }
          },
          onFormReady: function onFormReady() {
            setLoaded(true);

            _onFormReady();

            if (onReady) {
              onReady(elementRef.current);
            }
          }
        }, props);

        window.hbspt.forms.create(options);
      };

      var startCreateForm = function startCreateForm() {
        createForm();
      };

      if (!loaded) {
        startCreateForm();
      }
    }
  }, [id, elementRef, props, onSubmit, onReady, blockedDomains, isMounted, loaded, _onFormReady]);
  (0, _react.useEffect)(function () {
    if (status === 'ready') {
      setMounted(true);
    }
  }, [status]);
  (0, _react.useEffect)(function () {
    setupSubmitDisabled(submitDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitDisabled]);
  return id ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: [_stylesModule["default"].form, submitDisabled ? _stylesModule["default"]['form--submit-disabled'] : '', submitBlock ? _stylesModule["default"]['form--submit-block'] : '', className ? className : ''].join(' '),
    ref: elementRef,
    id: id,
    style: {
      display: loaded ? 'block' : 'none'
    }
  }), !loaded && loading ? loading : null) : loading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loading) : null;
};

var _default = HubspotForm;
exports["default"] = _default;